/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'billing': {
    width: 16,
    height: 16,
    viewBox: '0 0 512.000000 512.000000',
    data: `<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M1012 5100 c-109 -29 -187 -74 -272 -160 -87 -86 -131 -163 -160
-276 -20 -76 -20 -118 -20 -2104 0 -1986 0 -2028 20 -2104 29 -113 73 -190
160 -276 86 -87 163 -131 276 -160 75 -19 116 -20 1544 -20 1428 0 1469 1
1544 20 113 29 190 73 276 160 87 86 131 163 160 276 20 75 20 117 20 1713 l0
1636 -658 658 -657 657 -1080 -1 c-1030 0 -1083 -1 -1153 -19z m1948 -713 c0
-373 7 -426 72 -550 42 -81 164 -203 245 -245 124 -65 177 -72 550 -72 l333 0
-2 -1492 -3 -1493 -24 -38 c-13 -21 -42 -50 -64 -65 l-41 -27 -1466 0 -1466 0
-41 27 c-22 15 -51 44 -64 65 l-24 38 -3 2004 c-1 1390 1 2015 8 2043 13 48
77 114 122 127 20 5 405 10 951 10 l917 1 0 -333z m745 -465 c-97 -1 -183 2
-206 8 -51 14 -114 77 -128 127 -6 21 -11 114 -11 208 l0 170 255 -255 255
-255 -165 -3z"/>
<path d="M1759 3343 l0 -218 -72 -34 c-90 -43 -207 -157 -255 -248 -121 -231
-84 -504 94 -693 108 -114 235 -173 412 -190 105 -10 149 -30 187 -89 94 -143
-28 -334 -196 -307 -79 13 -180 82 -248 171 -26 34 -6 44 -209 -97 l-142 -99
22 -32 c81 -114 232 -239 352 -292 l56 -25 0 -215 0 -215 200 0 200 0 1 218 0
217 72 34 c100 47 210 158 261 261 66 135 82 276 46 414 -26 104 -72 187 -146
266 -109 115 -235 173 -413 190 -107 10 -153 33 -192 97 -19 30 -24 52 -24
105 0 58 4 72 30 109 83 118 245 113 376 -12 25 -24 55 -57 68 -74 26 -35 7
-43 209 97 l142 99 -22 32 c-81 114 -232 239 -352 292 l-56 25 0 215 0 215
-200 0 -200 0 -1 -217z"/>
<path d="M2960 2560 l0 -200 400 0 400 0 0 200 0 200 -400 0 -400 0 0 -200z"/>
<path d="M2960 1760 l0 -200 400 0 400 0 0 200 0 200 -400 0 -400 0 0 -200z"/>
<path d="M2960 960 l0 -200 400 0 400 0 0 200 0 200 -400 0 -400 0 0 -200z"/>
</g>`
  }
})
